import React from "react";
import Popup from "../popups/popup";
import I18n from "lib/i18n/i18n";
import { connect } from "react-redux";
import ScheduleShipment from "../scheduleShipment/scheduleShipment";
import UserActions from "lib/userActions";
import {
    STEP_PICKUP,
    OPENED_SCHEDULE_MODAL,
} from "../../helpers/ApplicationHelper";

class ScheduleShipmentModalPopup extends Popup {
    constructor(props) {
        super(props);
    }
    static initPopup(props = {}) {
        props.preventLocationBack = true;
        props.stopAnimation ? props.stopAnimation() : null;
        Popup.initPopup.call(this, props);

        const { itemId, version, logger } = props;
        const message = 'Set up shipment modal presented';
        window.localStorage.setItem(OPENED_SCHEDULE_MODAL+`_${itemId}`, true);

        if (logger) {
            logger(message, { itemId, version });
        } else {
            UserActions.listingPage(message, itemId, version);
        }
    }

    title() {
        const { step, isSKExperiment } = this.props;

        if (isSKExperiment && this.state.step === "request-shipping-kit") {
            return I18n.getString(`listingPage::allSet`);
        }

        const titleName = step === STEP_PICKUP ? 'scheduleShipmentTitle' : 'setUpShipmentTitle';

        return I18n.getString(`listingPage::${titleName}`);
    }

    _onPopupClose() {
        if (this.props.stopAnimation) {
            this.props.stopAnimation();
        }
    }

    imagesContent(faq) {
        return null;
    }

    tableContent(faq) {
        return null;
    }

    _changePopupTitleOnDesktop = () => {
        if (this.props.isSKExperiment) {
            this.setState({ step: "request-shipping-kit" });
        }
    };

    content() {
        const { step, logger, isSKExperiment} = this.props;
        return (
            <div className="schedule-shipment-custom-popup">
                <ScheduleShipment
                    isSKExperiment={isSKExperiment}
                    version={this.props.version}
                    onShipmentScheduled={this.props.onShipmentScheduled}
                    onShipmentScheduledViaPopup={() =>
                        this._changePopupTitleOnDesktop()
                    }
                    logger={logger}
                    onClose={(step, causedByError) => {
                        if (causedByError) {
                            this._hide();
                        }
                        this._onPopupClose(step);
                    }}
                    step={step}
                />
            </div>
        );
    }
}

ScheduleShipmentModalPopup.defaultProps = {
    popupClassName: "popup-schedule-secure-shipment",
    single: true,
    modal: true,
    onPopupClose: function () {
        this._onPopupClose();
    },
};

const mapStateToProps = ({ Item, ADO, Experiments, Personalized }) => {
    return {
        item: Item,
        ADO,
        experiments: Experiments,
        P13N: Personalized,
    };
};

export default connect(mapStateToProps)(ScheduleShipmentModalPopup);
